import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { grey, info, success, error, warning } from '../neutral/colors.js';
export { error, grey, info, success, warning } from '../neutral/colors.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var primary = {
  primary: '#ED1C23',
  primary900: '#C10004',
  primary800: '#CE0015',
  primary700: '#DB071E',
  primary600: '#ED1C23',
  primary500: '#FC2B22',
  primary400: '#F74342',
  primary300: '#ED6969',
  primary200: '#F69493',
  primary100: '#FFCACF',
  primary50: '#FFEAED'
};
var secondary = {
  secondary: '#FFE100',
  secondary900: '#F97000',
  secondary800: '#FB9C00',
  secondary700: '#FCB600',
  secondary600: '#FECE00',
  secondary500: '#FFE100',
  secondary400: '#FEE43D',
  secondary300: '#FFEA64',
  secondary200: '#FFF091',
  secondary100: '#FFF6BD',
  secondary50: '#FFFCE4'
};
var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, grey), primary), secondary), info), success), error), warning);

export { colors, primary, secondary };
//# sourceMappingURL=colors.js.map
